import { Injectable } from "@angular/core";
import { ParishConfigService } from "./services/parishconfig.service";
import { Router, UrlTree } from "@angular/router";
import { Device } from "@capacitor/device";

@Injectable()
export class AppSettings {
    constructor(private parishConfigService: ParishConfigService, private router: Router) { }
    apiBaseUrl = this.getApiUrl;
    uatTokenUrl = 'https://identity-uat.stminachurchca.com/connect/token';
    uatApiUrl = 'https://api-uat.stminachurchca.com/';
    backupApiUrl = 'https://api.stminachurchca.com/';

    getTokenUrl(): string {
        return this.uatTokenUrl;
        if (window.location.hostname.toLowerCase() === 'localhost' && window.location.port !== '') {
            return 'https://localhost:44351/connect/token';
        }
        else if (window.location.hostname.toLowerCase() === 'koinonia-uat.stminachurchca.com') {
            return this.uatTokenUrl;
        }
        else {
            return this.parishConfigService.getCurrentParishConfig()?.TokenUrl;
        }
    }

    getApiUrl(): string | UrlTree {
        return this.uatApiUrl;
        
        if (window.location.hostname.toLowerCase() === 'localhost' && window.location.port !== '') {
            return 'https://localhost:44360/';
        }
        else if (window.location.hostname.toLowerCase() === 'koinonia-uat.stminachurchca.com') {
            return this.uatApiUrl;
        }
        else {
            if (this.parishConfigService.getCurrentParishConfig()?.ApiUrl) {
                return this.parishConfigService.getCurrentParishConfig()?.ApiUrl;
            }
            else {
                return this.backupApiUrl;
            }
        }
    }

    openMaps(location: string) {
        Device.getInfo().then(device => {
            if (device.platform === 'ios') {
                window.location.href = 'maps://maps.apple.com/?q=' + location;
            } else {
                let url = `https://www.google.com/maps/search/${location}/`;
                window.open(url, '_blank');
            }
        });
    }

    openWhatsapp(inviteLink: string) {
        Device.getInfo().then(device => {
            if (device.platform === 'ios') {
                window.location.href = inviteLink;
            } else {
                window.open(inviteLink, '_blank');
            }
        });
    }
}